export interface Sinisters {
  id: number;
  numero_sinistro: string;
  numero_serie: string;
  status: number;
  criado_em: string;
  comunicado_por: number;
  empresa: Company;
  equipamento: Equipment;
  tipo: SinistersType;
  descricao: string;
  apolice_seguro: string;
  outro: string;
  boletim_ocorrencia: string;
  declaracao: string;
  criado_por: string;
  modificado_em: string;
  modificado_por: string;
  revisao_status?: string;
  revisao_comentario?: string;
  apolice_propria?: boolean;
  email: string;
  nota_de_debito_data_vencimento: string;
  emitente: SinistersIssuers;
  nota_de_debito_numero: string;
  nota_de_debito_referente: string;
  nota_de_debito_valor: string;
  nota_de_debito_visualizada: boolean;
  pode_registrar_apolice_seguro: boolean;
  pode_cancelar: boolean;
  pode_enviar_a_seguradora: boolean;
  pode_enviar_nota_de_debito: boolean;
  pode_comprovar_pagamento: boolean;
  pode_revisar_comunicado: boolean;
  pode_revisar_pagamento: boolean;
  pode_avaliar_pagamento: boolean;
  pode_baixar_nota_de_debito: boolean;
  pode_encerrar: boolean;
  existe_carta_positivo: boolean;
  existe_nota_de_remessa: boolean;
  existe_orcamento_de_reparo: boolean;
  existe_comprovante: boolean;
  existe_nota_de_debito: boolean;
  numero_apolice: string;
  seguradora: SinistersInsurers;
  contrato_encerrado: boolean;
}

export interface SinistersView extends Sinisters {
  colorScheme: string;
  formattedStatus: string;
  formattedDate: string;
  formattedValorNotaDebito: string;
}

export interface SinisterDocuments {
  id: number;
  nome: string;
  tipo: string;
  data_upload: string;
  id_check: number;
}

export interface SinistersType {
  id: number;
  nome: string;
  requer_boletim_ocorrencia: boolean;
}

export interface Company {
  id_empresa: number;
  cnpj: string;
  cliente: string;
  grupo: string;
}

export interface Equipment {
  modelo: number;
  sku: string;
  tipo_equipamento: string;
}

export interface SeriesNumber {
  numero_serie: number;
  id_contrato: number;
  id_empresa: number;
  cnpj?: string;
  empresa_razao_social?: string;
  equipamento_descricao?: string;
  equipamento_modelo?: string;
  equipamento_tipo?: string;
}

export interface SinistersLog {
  id: number;
  descricao: string;
  data_evento: string;
  sinistro: number;
  user: number;
  nome_usuario: string;
  formattedDate: string;
}

export interface SinistersDashboard {
  novo: number;
  em_analise: number;
  aguardando_envio: number;
  aguardando_pagamento: number;
  pagamento_em_analise: number;
  revisando_pagamento: number;
  enviando_para_seguradora: number;
  aguardando_entrega: number;
  encerrado: number;
  cancelado: number;
  revisao_pendente: number;
  revisado: number;
  total: number;
}

export interface SinistersInsurers {
  id: number;
  nome: string;
  email: string;
}

export interface SinistersIssuers {
  id: number;
  nome: string;
  cnpj: string;
  cnpj_formatado: string;
  endereco: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  banco: string;
  codigo_banco: string;
  agencia: string;
  conta: string;
  titular: string;
}

export interface SinisterDebitNoteConfiguration {
  nota_de_debito_texto_padrao: string;
  data_vencimento: string;
}

export interface SinisterDebitNote {
  referente: string;
  data_de_vencimento: string;
  id_emitente: number;
  valor: number;
  numero_nota_debito: string;
}

// eslint-disable-next-line no-shadow
export enum SinisterStatusEnum {
  'NOVO',
  'EM ANÁLISE',
  'AGUARDANDO ENVIO',
  'AGUARDANDO PAGAMENTO',
  'PAGAMENTO EM ANÁLISE',
  'REVISAR PAGAMENTO',
  'ENVIADO À SEGURADORA',
  'AGUARDANDO ENTREGA',
  'ENCERRADO',
  'CANCELADO',
  'REVISÃO PENDENTE',
  'REVISADO',
}

// eslint-disable-next-line no-shadow
export enum SinisterColorsEnum {
  'red',
  'teal',
  'twitter',
  'purple',
  'green',
  'cyan',
  'telegram',
  'linkedin',
  'facebook',
  'blackAlpha',
  'messenger',
  'whatsapp',
}

// eslint-disable-next-line no-shadow
export enum SinistersDocuments {
  'DECLARACAO',
  'APOLICE_SEGURO',
  'BOLETIM_OCORRENCIA',
  'OUTRO',
  'CARTA_POSITIVO',
  'NOTA_DE_REMESSA',
  'ORCAMENTO_DE_REPARO',
  'COMPROVANTE_DE_PAGAMENTO',
  'TERMO_DE_INDENIZACAO',
}

// eslint-disable-next-line no-shadow
export enum SinisterOrderEnum {
  'DEFAULT' = '-criado_em',
  'SKU' = 'sku',
  'SERIE' = 'serie',
  'SINISTRO' = 'numero_sinistro',
  'EQUIPAMENTO' = 'modelo',
  'CLIENTE' = 'cliente',
  'GRUPO' = 'grupo',
  'RESPONSAVEL' = 'responsavel',
}
